import { getTransform } from "./transform";
import { normalizeColor } from "./color";

/**
 * Applies markdown-like formatting to a text block.
 */
export function applyFormatting(text: string): string {
  return text
    // Inline animation: ^^text^^(delay, animation)
    .replace(/\^\^(.+?)\^\^\(([\d.]+),\s*(\w[\w-]*)\)/g, (_, t, d, a) =>
      `<span class="inline-block opacity-0 transition duration-500 ${getTransform(a)}" style="transition-delay:${d}s;" data-anim-delay="${d}">${applyFormatting(t)}</span>`
    )
    // Inline combined color and background using {{color/bg|text}}
    .replace(/\{\{(#[\da-fA-F]{3,6}|\w+)\/(#[\da-fA-F]{3,6}|\w+)\|(.+?)\}\}/g,
      (_, color, bg, inner) =>
        `<span style="color:${normalizeColor(color)}; background-color:${normalizeColor(bg)}; padding: 0.1em 0.4em; border-radius: 0.25rem;">${inner}</span>`
    )
    // Inline color using {{color|text}}
    .replace(/\{\{(#[\da-fA-F]{3,6}|\w+)\|(.+?)\}\}/g,
      (_, color, inner) => `<span style="color:${normalizeColor(color)};">${inner}</span>`
    )
    // Inline background color using {{bg-color|text}}
    .replace(/\{\{bg-(#[\da-fA-F]{3,6}|\w+)\|(.+?)\}\}/g,
      (_, bg, inner) => `<span style="background-color:${normalizeColor(bg)}; padding: 0.1em 0.4em; border-radius: 0.25rem;">${inner}</span>`
    )
    /*
    // Inline text color: ^red^Text^ or ^#4caf50^Text^
    .replace(/\^\s*(#[\da-fA-F]{3,6}|\w+)\s*\^(.*?)\^/g,
      (_, color, inner) => `<span style="color:${normalizeColor(color)};">${inner}</span>`
    )
    // Inline background color: ^bg-yellow^Text^ or ^bg-#ffeaa7^Text^
    .replace(/\^bg-(#[\da-fA-F]{3,6}|\w+)\^(.*?)\^/g,
      (_, bg, inner) => `<span style="background-color:${normalizeColor(bg)}; padding: 0.1em 0.4em; border-radius: 0.25rem;">${inner}</span>`
    )
    */
    // Bold and italic
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.*?)\*/g, "<em>$1</em>")
    .replace(/_(.*?)_/g, "<em>$1</em>");
}